{
  "adminPanel": {
    "licenseRequests": {
      "responseFileHint": "If you want to download the license file generated for the license, go to the IssuesLicenses or MyLicenseRequests tab after the approval process."
    }
  },
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password",
    "login_title": "Login",
    "no_account": "Don't have an account?",
    "create_account": "Create account",
    "email_or_username": "Email or Username",
    "forgot_password": "Forgot password?",
    "forgot_password_title": "Forgot your password?",
    "forgot_password_description": "Enter your email address and we will send you instructions to reset your password.",
    "email_not_found": "The email address entered was not found in our system. Please check the address and try again.",
    "send_mail_success": "A password reset link has been successfully sent to your email address.",
    "send_mail_error": "Password reset email could not be sent. Please try again later.",
    "send_reset_email": "Send Reset Email",
    "back_to_login": "Back to login",
    "password_reset_request_sent": "Password reset instructions have been sent to your email",
    "need_help": "Need Help?",
    "contact_support_message": "Contact our support team for password reset assistance:",
    "check_email_title": "Password Reset Support",
    "check_email_description": "For password reset assistance, please contact our support team using the information below. Our team will help you regain access to your account.",
    "need_assistance": "Need Assistance?",
    "contact_support_reset_message": "Contact our support team for password reset assistance:",
    "visit_for_support": "Visit our website for support and assistance",
    "login_success": "You've successfully logged in",
    "signup_title": "Sign up",
    "have_account": "Have an account?",
    "first_name": "First Name",
    "last_name": "Last Name",
    "username": "Username",
    "username_optional": "Username (optional, email will be used if not provided)",
    "repeat_password": "Repeat Password",
    "signup_success": "You've successfully signed up! You can now log in.",
    "validation": {
      "required": {
        "first_name": "First name is required",
        "last_name": "Last name is required",
        "email": "Email field is required",
        "password": "Password field is required",
        "repeat_password": "Repeat Password field is required"
      },
      "email": "Email should be valid",
      "password": {
        "length": "Password must be at least 8 characters long",
        "letter": "Password must contain at least one letter",
        "number": "Password must contain at least one number",
        "special": "Password must contain at least one special character",
        "match": "Passwords don't match"
      }
    }
  },
  "billing": {
    "comingSoon": {
      "title": "Billing System",
      "subtitle": "Our comprehensive billing and invoicing system is currently under development and will be available soon."
    }
  },
  "404": {
    "title": "This page's gone fishing.",
    "text": "If you feel that it's not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar",
    "welcome": {
      "title": "Welcome back",
      "subtitle": "Your secure license management platform powered by RAKORT.",
      "defaultUser": "User"
    },
    "features": {
      "licenseManagement": {
        "title": "License Management System",
        "description": "Comprehensive online and offline license validation and tracking"
      },
      "dataProtection": {
        "title": "Enterprise Data Protection",
        "description": "Safeguarding your company's valuable intellectual property"
      },
      "compliance": {
        "title": "Compliance & Governance",
        "description": "Ensuring regulatory compliance and license usage policies"
      },
      "assetManagement": {
        "title": "Asset Management",
        "description": "Complete visibility and control over digital assets and licenses"
      },
      "status": "Operational"
    },
    "licenseTypes": {
      "online": {
        "title": "Online Licenses",
        "description": "Cloud-based license validation",
        "status": "Online Support"
      },
      "offline": {
        "title": "Offline Licenses",
        "description": "Air-gapped system protection",
        "status": "Offline Support"
      },
      "enterprise": {
        "title": "Enterprise Protection",
        "description": "Securing company data assets",
        "status": "Full Protection"
      }
    },
    "compliance": {
      "title": "Enterprise License Management & Security",
      "items": {
        "onlineValidation": "Online License Validation",
        "offlineProtection": "Offline License Protection",
        "dataSecurity": "Enterprise Data Security",
        "assetProtection": "Company Asset Protection",
        "complianceManagement": "Compliance Management",
        "riskAssessment": "Risk Assessment & Mitigation",
        "digitalRights": "Digital Rights Management",
        "intellectualProperty": "Intellectual Property Defense"
      }
    }
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian",
    "turkish": "Turkish"
  },
  "menu": {
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "billing": "Billing",
    "login": "Login",
    "preferences": "Account preferences",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "license-requests": "License requests",
    "404": "404",
    "faq": "FAQ",
    "threatIntelligence": "Threat Intelligence",
    "users": "Users",
    "projects": "Projects",
    "template-plans": "Plan Templates",
    "resolutionCenter": "Resolution Center",
    "mySupportTickets": "My Support Tickets",
    "myLicenses": "My Licenses",
    "licenseRequests": "License Requests",
    "purchasedLicenses": "Purchased Licenses",
    "issuedLicenses": "Issued Licenses",
    "manageFeatures": "Manage Features",
    "manageServices": "Manage Services",
    "logMonitor": "Log Monitor",
    "mfaAuthenticator": "MFA Authenticator",
    "updates": "Updates"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic",
    "noNotifications": {
      "title": "No notifications",
      "message": "You're all caught up! No new notifications at this time."
    },
    "types": {
      "licenseExpiry": "License expiry warnings",
      "licenseRequests": "License requests",
      "systemAlerts": "System alerts",
      "messaging": "Messaging",
      "supportTickets": "Support tickets",
      "securityAlerts": "Security alerts",
      "maintenanceUpdates": "Maintenance updates",
      "billingNotifications": "Billing notifications",
      "accountUpdates": "Account updates",
      "newsAndUpdates": "Product news and updates"
    }
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore"
  },
  "faq": {
    "title": "Frequently Asked Questions",
    "popularQuestions": "Popular Questions",
    "categories": {
      "licenseManagement": {
        "name": "License Management",
        "intro": "License management and activation processes"
      },
      "networkSecurity": {
        "name": "Network Security",
        "intro": "Network security solutions and configurations"
      },
      "technicalSupport": {
        "name": "Technical Support",
        "intro": "Getting help and technical assistance"
      },
      "enterpriseSolutions": {
        "name": "Enterprise Solutions",
        "intro": "Enterprise-level solutions and integrations"
      },
      "training": {
        "name": "Training & Education",
        "intro": "Professional training and certification programs"
      },
      "productInfo": {
        "name": "Product Information",
        "intro": "Details about our products and features"
      },
      "installation": {
        "name": "Installation & Setup",
        "intro": "Installation guides and initial configuration"
      },
      "contact": {
        "name": "Contact & Sales",
        "intro": "Sales inquiries and contact information"
      },
      "updates": {
        "name": "Updates & Maintenance",
        "intro": "Software updates and system maintenance"
      }
    },
    "demo": {
      "title": "Got questions?",
      "description": "Request a free demo to have all your questions answered by an expert.",
      "button": "Request a demo",
      "modal": {
        "title": "Request free demo",
        "description": "Claim your spot now and ignite innovation with our exceptional software solution! 🔥",
        "emailLabel": "Email",
        "submitButton": "Request demo",
        "emailRequired": "Email field is required",
        "emailValid": "Email should be valid",
        "successTitle": "Demo Request Submitted!",
        "successMessage": "An expert will get in touch soon"
      }
    },
    "questions": {
      "whatIsFastNAC": {
        "title": "What is FastNAC and how does it work?",
        "content": {
          "intro": "FastNAC is a next-generation Network Access Control (NAC) solution developed by Rakort. It is developed entirely with domestic and national technologies."
        },
        "feature1": "Unique technology that can work without Radius and Agent integration",
        "feature2": "Allows you to keep access control in your corporate network completely in your hands",
        "feature3": "Prevents unauthorized access by keeping your network security at the highest level",
        "feature4": "Quick deployment with easy installation and management interface"
      },
      "whatProducts": {
        "title": "What products do you have?",
        "content": {
          "intro": "Our products developed as a result of R&D activities as Rakort Information and Communication Technologies:",
          "conclusion": "All our products are developed with domestic and national technologies and offer special solutions for public and private sector needs."
        }
      },
      "technicalSupport": {
        "title": "How can I get technical support?",
        "content": {
          "intro": "As Rakort, we provide comprehensive technical support services to our customers:",
          "conclusion": "Within the scope of the Service Center, we provide technical support services to provide high SLA conditions for software, hardware and telecommunication solutions to our customers."
        }
      },
      "trainingServices": {
        "title": "What are your training services?",
        "content": {
          "intro": "As Rakort, we provide professional training services on network technologies:",
          "instructors": "Our expert instructors provide professional training services with up-to-date curricula that follow innovations and developments.",
          "contact": "For your training request, you can contact info\\u0040rakort.com or call 0850 460 10 58."
        }
      },
      "licenseManagement": {
        "title": "How does license management work?",
        "content": {
          "intro": "Our license management platform offers secure solutions with online and offline license verification technologies:",
          "conclusion": "You can get support from our expert team on license model selection and integration suitable for your corporate structure."
        }
      },
      "contactInfo": {
        "title": "What are your contact details?",
        "content": {
          "intro": "Contact information with Rakort Information and Communication Technologies Ltd. Co.:",
          "contactHeader": "Contact Information",
          "phoneLabel": "Phone",
          "emailLabel": "Email",
          "addressLabel": "Address",
          "contact": {
            "phone": "0850 460 10 58",
            "email": "info\\u0040rakort.com",
            "address": "Mustafa Kemal Mah. 2139 Cad. Ekim Plaza No: 2 Kat: 2 Daire: 11 Çankaya / Ankara"
          },
          "conclusion": "We are here to provide you with the best service during our working hours. Contact us for consulting and solution suggestions for your projects."
        }
      }
    },
    "products": {
      "fastNAC": {
        "name": "FastNAC",
        "desc": "Next-generation network access control system"
      },
      "arkSpot": {
        "name": "ArkSpot",
        "desc": "Secure WiFi access management solution"
      },
      "rakortCall": {
        "name": "RakortCall",
        "desc": "Corporate voice communication systems"
      },
      "rakortLog": {
        "name": "RakortLog",
        "desc": "Network security and log management system"
      },
      "racGuard": {
        "name": "RacGuard",
        "desc": "Security solution under development"
      },
      "secration": {
        "name": "Secration",
        "desc": "Security product under development"
      }
    },
    "support": {
      "phone": {
        "type": "Phone Support",
        "desc": "You can get support during working hours from our phone line 0850 460 10 58"
      },
      "email": {
        "type": "Email Support",
        "desc": "You can send your detailed questions to info\\u0040rakort.com"
      },
      "remote": {
        "type": "Remote Support",
        "desc": "We provide quick solutions via remote connection when necessary"
      },
      "onsite": {
        "type": "On-site Support",
        "desc": "We provide on-site technical support for critical systems"
      }
    },
    "training": {
      "product": {
        "type": "Product Training",
        "desc": "Detailed training on the use of FastNAC, ArkSpot, RakortCall and our other products"
      },
      "security": {
        "type": "Network Security Training",
        "desc": "Expert training on network security, firewall management and security policies"
      },
      "linux": {
        "type": "Linux/Unix Training",
        "desc": "Expert training on system administration, configuration and security"
      },
      "custom": {
        "type": "Custom Solution Training",
        "desc": "Training programs specially developed for customer needs"
      }
    },
    "license": {
      "online": {
        "type": "Online Licenses",
        "desc": "Cloud-based verification for systems with internet connection"
      },
      "offline": {
        "type": "Offline Licenses",
        "desc": "File-based verification for secure environments without internet access"
      },
      "central": {
        "type": "Central Management",
        "desc": "Ability to manage all your licenses from a single panel"
      },
      "reporting": {
        "type": "Reporting",
        "desc": "Detailed usage reports and license status tracking"
      }
    },
    "contact": {
      "sales": {
        "type": "Sales and Quotes",
        "desc": "To get information about our products and request quotes"
      },
      "technical": {
        "type": "Technical Support",
        "desc": "Help with installation, configuration and troubleshooting"
      },
      "training": {
        "type": "Training Requests",
        "desc": "Information about our professional training programs"
      },
      "general": {
        "type": "General Questions",
        "desc": "General information about our company and services"
      }
    }
  },
  "preferences": {
    "memberSince": "Member since",
    "name": "Name",
    "edit": "Edit",
    "resetPassword": "Reset Password",
    "twoFactorAuth": "Two-factor authentication",
    "twoFactorAuthEnabledContent": "Two-Factor Authentication (2FA) is now enabled for your account, adding an extra layer of security to your sign-ins.",
    "twoFactorAuthDisabledContent": "Add an extra layer of security to your account. To sign in, you'll need to provide a code along with your username and password.",
    "disable2FA": "Disable 2FA",
    "setup2FA": "Set up 2FA",
    "emailSubscriptions": "Email subscriptions",
    "manageEmailSubscriptions": "To manage what emails you get, visit the",
    "notificationSettings": "Notification settings",
    "editName": "Edit Name",
    "save": "Save",
    "changeNameSuccess": "You've successfully changed your name",
    "oldPassword": "Old password",
    "newPassword": "New password",
    "repeatNewPassword": "Repeat new password",
    "passwordUniqueChars": "Must contain at least 6 unique characters",
    "updatePassword": "Update Password",
    "changePasswordSuccess": "You've successfully changed your password!",
    "oldPasswordIncorrect": "Old password is incorrect",
    "oldPasswordRequired": "Old password field is required",
    "newPasswordRequired": "New password field is required",
    "newPasswordCannotBeSame": "New password cannot be the same as the old password",
    "repeatNewPasswordRequired": "Repeat new password field is required",
    "confirmPasswordNoMatch": "Confirm password does not match new password"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "supportAndConsulting": "Support & Consulting",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "vuestic": {
    "search": "Search",
    "noOptions": "Items not found",
    "ok": "OK",
    "cancel": "Cancel",
    "uploadFile": "Upload file",
    "undo": "Undo",
    "dropzone": "Drop files here to upload",
    "fileDeleted": "File deleted",
    "closeAlert": "close alert",
    "backToTop": "back to top",
    "toggleDropdown": "toggle dropdown",
    "carousel": "carousel",
    "goPreviousSlide": "go previous slide",
    "goNextSlide": "go next slide",
    "goSlide": "go slide {index}",
    "slideOf": "slide {index} of {length}",
    "close": "close",
    "openColorPicker": "open color picker",
    "colorSelection": "color selection",
    "colorName": "color {color}",
    "decreaseCounter": "decrease counter",
    "increaseCounter": "increase counter",
    "selectAllRows": "select all rows",
    "sortColumnBy": "sort column by {name}",
    "selectRowByIndex": "select row {index}",
    "resetDate": "reset date",
    "nextPeriod": "next period",
    "switchView": "switch view",
    "previousPeriod": "previous period",
    "removeFile": "remove file",
    "reset": "reset",
    "pagination": "pagination",
    "goToTheFirstPage": "go to the first page",
    "goToPreviousPage": "go to the previous page",
    "goToSpecificPage": "go to the {page} page",
    "goToSpecificPageInput": "enter the page number to go",
    "goNextPage": "go next page",
    "goLastPage": "go last page",
    "currentRating": "current rating {value} of {max}",
    "voteRating": "vote rating {value} of {max}",
    "optionsFilter": "options filter",
    "splitPanels": "split panels",
    "movePaginationLeft": "move pagination left",
    "movePaginationRight": "move pagination right",
    "resetTime": "reset time",
    "closeToast": "close toast",
    "selectedOption": "Selected option",
    "noSelectedOption": "Option is not selected",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "counter value",
    "selectedDate": "selected date",
    "selectedTime": "selected time",
    "progressState": "progress state",
    "color": "color",
    "next": "Next",
    "back": "Previous",
    "finish": "Finish",
    "step": "step",
    "progress": "progress",
    "loading": "Loading",
    "sliderValue": "Current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "File type is incorrect",
    "select": "Select an option"
  },
  "errors": {
    "unknown": "Unknown error"
  },
  "sidebar": {
    "buyLicense": "Buy License"
  },
  "settings": {
    "theme": "Theme",
    "generalPreferences": "General preferences",
    "notificationsYouReceive": "Notifications you receive"
  },
  "resolutionCenter": {
    "title": "Resolution Center",
    "description": "You can track your support tickets here.",
    "adminTitle": "Admin Resolution Center",
    "adminDescription": "Manage and monitor all support tickets from users.",
    "myTicketsTitle": "My Support Tickets",
    "allTicketsTitle": "All Support Tickets",
    "createTicketTitle": "Create New Support Ticket",
    "ticketDetailsTitle": "Ticket #{id} - {subject}",
    "openCenter": "Open Center",
    "createNewTicket": "Create New Ticket",
    "viewTicket": "View",
    "sendMessage": "Send Message",
    "closeTicket": "Close Ticket",
    "submitTicket": "Submit Ticket",
    "cancel": "Cancel",
    "backToList": "Back to List",
    "backToMyTickets": "Back to My Tickets",
    "user": "User",
    "type": "Type",
    "created": "Created",
    "lastUpdate": "Last Update",
    "messages": "Messages",
    "reply": "Reply",
    "yourReply": "Your Reply",
    "noMessagesYet": "No messages yet.",
    "typeYourMessage": "Type your message here...",
    "ticketClosed": "This ticket is closed.",
    "ticketStatus": "This ticket is {status}.",
    "loadingTicket": "Loading ticket details or ticket not found...",
    "noSupportTickets": "You have no support tickets.",
    "noTicketsFound": "No tickets found.",
    "ticketNotFound": "Ticket not found.",
    "createFirstTicket": "Create Your First Ticket",
    "subject": "Subject",
    "ticketType": "Ticket Type",
    "priority": "Priority",
    "priorityHigh": "High",
    "priorityMedium": "Medium",
    "priorityLow": "Low",
    "typeCustom": "Custom Ticket",
    "typeLicense": "License Request",
    "describeIssue": "Describe your issue",
    "enterSubject": "Enter a brief subject for your ticket",
    "provideDetails": "Please provide as much detail as possible...",
    "validationRequired": "Please fill in all required fields.",
    "fillAllFields": "Please fill in all required fields.",
    "ticketSubmittedSuccess": "Ticket submitted successfully! (Mock)",
    "ticketCreated": "Ticket created successfully!",
    "ticketClosedSuccess": "Ticket closed successfully.",
    "ticketInProgressSuccess": "Ticket marked as in progress.",
    "ticketDevelopingSuccess": "Ticket sent to developing.",
    "messageSentSuccess": "Message sent successfully.",
    "errorCreating": "Error creating ticket.",
    "errorFetchingTicket": "Error fetching ticket details.",
    "errorClosingTicket": "Error closing ticket.",
    "errorMarkingTicketAsInProgress": "Error marking ticket as in progress.",
    "errorMarkingTicketAsDeveloping": "Error sending ticket to developing.",
    "errorSendingMessage": "Error sending message.",
    "inProgress": "Mark as In Progress",
    "developing": "Send to Developing",
    "statsTotal": "Total",
    "statsOpen": "Open",
    "statsInProgress": "In Progress",
    "statsDeveloping": "Developing",
    "statsResolved": "Resolved",
    "statsClosed": "Closed",
    "statsResolvedOrClosed": "Resolved/Closed",
    "admin": "Admin",
    "support": "Support",
    "you": "You",
    "refresh": "Refresh",
    "export": "Export",
    "view": "View",
    "edit": "Edit",
    "filter": "Filter",
    "sort": "Sort",
    "loadingTickets": "Loading tickets...",
    "noTickets": "No Support Tickets",
    "manageMonitorTickets": "Manage and monitor all support tickets",
    "allTypes": "All Types",
    "technical": "Technical",
    "billing": "Billing",
    "general": "General",
    "featureRequest": "Feature Request",
    "allPriorities": "All Priorities",
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "critical": "Critical",
    "allStatus": "All Status",
    "open": "Open",
    "resolved": "Resolved",
    "closed": "Closed",
    "filterByType": "Filter by type",
    "filterByPriority": "Filter by priority",
    "filterByStatus": "Filter by status",
    "searchPlaceholder": "Search tickets...",
    "searchMyTickets": "Search my tickets...",
    "reset": "Reset",
    "status": "Status",
    "itemsPerPage": "Items per page",
    "showing": "Showing",
    "of": "of",
    "errorFetchingStats": "Failed to fetch ticket statistics"
  },
  "common": {
    "confirm": "Confirm",
    "retry": "Retry",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "refresh": "Refresh",
    "copied": "Code copied to clipboard",
    "copyFailed": "Failed to copy code"
  },
  "pricingPlans": {
    "header": {
      "title": "Choose the Right Plan for Your Business",
      "subtitle": "Select a plan that best fits your organization's needs and budget"
    },
    "tabs": {
      "custom": "Custom"
    },
    "navigation": {
      "previousPlan": "Previous plan",
      "nextPlan": "Next plan",
      "goToSlide": "Go to slide {slideNumber}"
    },
    "planCard": {
      "currentPlan": "Current Plan",
      "selectPlan": "Select Plan",
      "featuresAndBenefits": "Features & Benefits"
    },
    "customPlanCard": {
      "title": "Custom Plan",
      "description": "Build your own plan by selecting exactly the features you need",
      "customizePlan": "Customize Plan",
      "benefitsTitle": "Custom Plan Benefits",
      "benefitChooseFeatures": "Choose only the features you need",
      "benefitPayForUse": "Pay only for what you use",
      "benefitFlexible": "Flexible for growing businesses",
      "benefitScalable": "Scale as your needs change"
    },
    "actions": {
      "continueWithPlan": "Continue with {planName}"
    },
    "notifications": {
      "loadFailed": "Failed to load pricing plans. Please try again later.",
      "planChangeSuccess": "You successfully changed your payment plan!",
      "customPlanSelected": "Custom plan selected. You can now choose your features.",
      "planDetailsNotFound": "Could not find selected plan details."
    },
    "modal": {
      "confirmPlanChange": {
        "title": "Confirm Plan Change",
        "message": "Are you sure you want to change your plan?"
      }
    },
    "plan": {
      "descriptionSuffix": "Plan for your needs"
    }
  },
  "payments": {
    "title": "Payment Methods",
    "myCards": "My cards",
    "billingAddress": "Billing address",
    "taxLocation": "Tax location",
    "taxInfo": "United States - 10% VAT",
    "moreInfo": "More info",
    "enterprise": {
      "header": {
        "title": "Enterprise Payment Processing",
        "subtitle": "Secure • Personalized • Professional"
      },
      "manual": {
        "title": "Manual Payment System",
        "description": "We currently operate with a manual payment processing system for enhanced security and personalized service. Our enterprise support team will guide you through the entire payment process to ensure your specific business needs are met."
      },
      "whyManual": {
        "title": "Why Manual Processing?",
        "security": "Enhanced security with human verification",
        "customized": "Customized enterprise solutions",
        "support": "Direct support for complex requirements",
        "flexible": "Flexible payment terms and invoicing"
      },
      "contact": {
        "title": "Enterprise Support Contact",
        "phone": {
          "label": "Direct Line",
          "number": "0850 460 10 58",
          "hours": "Business Hours: 9:00 - 18:00"
        },
        "email": {
          "label": "Enterprise Sales",
          "addressPrefix": "info",
          "addressSuffix": "rakort.com",
          "response": "Response within 2 hours"
        }
      },
      "process": {
        "title": "Payment Process",
        "step1": "Contact our enterprise team",
        "step2": "Discuss requirements & pricing",
        "step3": "Secure payment processing",
        "step4": "Immediate service activation"
      },
      "actions": {
        "callSupport": "Call Enterprise Support",
        "sendInquiry": "Send Inquiry",
        "emailSubject": "Enterprise Payment Inquiry"
      },
      "footer": {
        "note": "* The card management interface above will be available after payment setup is completed"
      },
      "trust": {
        "security": "Enterprise Security",
        "support": "24/7 Support",
        "solutions": "Custom Solutions"
      }
    }
  },
  "mfaAuthenticator": {
    "title": "MFA Authenticator",
    "description": "Manage and monitor your Multi-Factor Authentication codes",
    "currentCode": {
      "title": "Current TOTP Code",
      "label": "Verification Code",
      "timeRemaining": "Time Remaining",
      "nextRefresh": "Next Refresh",
      "refresh": "Refresh Code"
    },
    "verification": {
      "title": "Code Verification",
      "codeLabel": "Enter TOTP Code",
      "codePlaceholder": "123456",
      "verify": "Verify Code",
      "required": "Code is required",
      "success": "Code Verified",
      "failed": "Verification Failed",
      "successMessage": "TOTP code verified successfully"
    },
    "settings": {
      "title": "MFA Settings",
      "status": "MFA Status",
      "enabled": "Multi-Factor Authentication is enabled",
      "disabled": "Multi-Factor Authentication is disabled",
      "qrCode": "QR Code Setup",
      "qrInstructions": "Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.)",
      "generateNew": "Generate New QR Code",
      "qrNotActivated": "QR Not Activated",
      "contactAdminForQr": "Contact your system administrator to activate QR code setup",
      "contactAdmin": "Contact Admin"
    },
    "admin": {
      "title": "Administration Notice",
      "description": "For QR code activation, advanced settings, or technical support, please contact your system administrator.",
      "contactSupport": "Contact Support"
    },
    "errors": {
      "fetchFailed": "Failed to fetch current MFA code",
      "verificationFailed": "Failed to verify MFA code",
      "provisioningFailed": "Failed to generate provisioning data"
    }
  },
  "updates": {
    "title": "Updates",
    "description": "Manage and monitor your updates",
    "add_new": "Add New Update",
    "step_1": "Step 1: Upload Files",
    "step_2": "Step 2: Enter Commands",
    "backend_files": "Backend Files",
    "frontend_files": "Frontend Files",
    "other_files": "Additional Files (Optional)",
    "other_files_error": "Please provide a path for each extra file.",
    "version": "Version",
    "change_log": "Change Log",
    "type": "Type",
    "time": "Time",
    "failed_to_load_updates": "Failed to load updates: Invalid data format.",
    "backend_file_error": "File must be named backend.zip",
    "frontend_file_error": "File must be named frontend.zip",
    "please_select_both_files": "Please select both backend and frontend files.",
    "files_uploaded_successfully": "Files uploaded successfully!",
    "failed_to_upload_files": "Failed to upload files: ",
    "commands_sent_successfully": "Commands sent successfully!",
    "failed_to_send_commands": "Failed to send commands: ",
    "go_back": "Go Back",
    "next": "Next",
    "finish": "Finish",
    "upload_files": "Upload Files",
    "please_wait_while_files_are_uploading": "Please wait while files are uploading",
    "enter_commands": "Enter Commands",
    "add_command": "Add Command",
    "command": "Command",
    "finish_process": "Update Process Complete",
    "all_steps_completed_successfully": "All steps have been completed successfully!",
    "update_files_uploaded_and_commands_sent": "The update files uploaded and commands sent. You may close this dialog.",
    "header_placeholder": "Enter your changelog details here...",
    "step_3": "Step 3: Enter Changelog",
    "header": "Header",
    "change_log_placeholder": "Enter your changelog details here...",
    "major": "Major",
    "minor": "Minor",
    "version_placeholder": "Enter the version number",
    "failed_to_send_step3": "Failed to send step 3: ",
    "step3_required_fields": "Please fill in all fields",
    "step3_success": "Data sent successfully.",
    "refresh": "Refresh",
    "verified": "Verified",
    "not_verified": "Not Verified",
    "partially_verified": "Partially Verified",
    "is_verified": "Verification Status",
    "verify": "Verify",
    "actions": "Actions",
    "username": "Username",
    "user_verified_successfully": "User verified successfully",
    "customer_update_history": "Customer Update History",
    "license_key": "License Key",
    "customer": "Customer",
    "search_customer": "Search customer...",
    "search_version": "Search version...",
    "search_license_key": "Search license key...",
    "clear_filters": "Clear Filters",
    "license_key_copied": "License key copied!",
    "fileUpload": {
      "description": "You can read your .req files here (Maximum 500KB, at least 2 lines)",
      "dragDropTitle": "Drag .req file here",
      "dragDropSubtitle": "or click to select .req file",
      "selectFileButton": "Select .req File",
      "selectedFile": "Selected File",
      "fileContent": "File Content",
      "fileContentLines": "lines",
      "authLine": "Auth Line (First Line):",
      "authLinePlaceholder": "Auth information will appear here",
      "allLines": "All Lines:",
      "processFile": "Process File",
      "processing": "Processing...",
      "fileSizeLimit": "File size cannot exceed 500KB",
      "fileExtensionError": "Please select only .req files",
      "minLinesError": "File must contain at least 2 lines (1st line: lic_key, 2nd line: data)",
      "minLinesErrorShort": "File must contain at least 2 lines",
      "selectFileError": "Please select a .req file",
      "authRequestFailed": "Auth request failed: ",
      "listRequestFailed": "List request failed: ",
      "requestsCompleted": "Requests completed successfully!",
      "requestError": "Request error: ",
      "unknownError": "Unknown error",
      "tableTitle": "Update List",
      "version": "Version",
      "changeLog": "Change Log",
      "type": "Type",
      "download": "Download",
      "downloadable": "Downloadable",
      "notDownloadable": "Not Downloadable",
      "upToDate": "You're up to date!",
      "noData": "You are on the latest version. No updates available.",
      "downloading": "Downloading...",
      "downloadSuccess": "File downloaded successfully: ",
      "downloadFailed": "Download failed: ",
      "downloadError": "Download error: "
    }
  },
  "vaDataTable": {
    "id": "Ticket ID",
    "status": "Status"
  },
  "licenseStatus": {
    "active": "Active",
    "notActivated": "Not Activated",
    "deactivated": "Deactivated"
  },
  "threatIntelligence": {
    "title": "Real-time Threat Intelligence",
    "search": "Search vulnerabilities...",
    "vulnerabilities": "Known Vulnerabilities",
    "available": "Available",
    "pending": "Pending",
    "fixedVersion": "Fixed Version"
  }
}
